import React from "react";
import LoadingScreen from "../UI/loading-screen";
// import ErrorComponent from '../UI/error';
import ErrorComponent from "../errors/error-box";
import SingleCard from "../UI/single-card";
import MultiCard from "../UI/multi-card";
import ProductSelectMobile from "../UI/product-select-mobile";

const desktopProductView = (dProps, benefitsTranslations, refundWidgetToggle) => {
  const {
    products,
    languages,
    selectMembership,
    couponObj,
    locationData,
    isUserLogged,
    locationDataCurrency,
    businessCategories,
  } = dProps || {};

  if (products && products.length > 1) {
    return (
      <MultiCard
        languages={languages}
        products={products}
        selectMembership={selectMembership}
        couponObj={couponObj}
        locationData={locationData}
        isUserLogged={isUserLogged}
        locationDataCurrency={locationDataCurrency}
        businessCategories={businessCategories}
        benefitsTranslations={benefitsTranslations}
        refundWidgetToggle={refundWidgetToggle}
      />
    );
  } else {
    return (
      <SingleCard
        languages={languages}
        product={products}
        selectMembership={selectMembership}
        couponObj={couponObj}
        locationData={locationData}
        isUserLogged={isUserLogged}
        locationDataCurrency={locationDataCurrency}
        businessCategories={businessCategories}
        benefitsTranslations={benefitsTranslations}
        refundWidgetToggle={refundWidgetToggle}
      />
    );
  }
};

function Product({
  locationData,
  selectMembership,
  languages,
  error,
  isProductLoaded,
  isProductLoading,
  products,
  locationDataCurrency,
  couponObj,
  isUserLogged,
  businessCategories,
  benefitsTranslations,
  refundWidgetToggle
}) {
  const productData = {
    languages,
    products,
    selectMembership,
    couponObj,
    locationData,
    isUserLogged,
    locationDataCurrency,
    businessCategories,
  };
  console.log("ProductComponent - isProductLoaded up", { isProductLoaded, isProductLoading });

  if (isProductLoading) {
    console.log("ProductComponent - inside", { isProductLoaded, isProductLoading });
    return <LoadingScreen />;
  } else if (!isProductLoaded && !isProductLoading) {
    return <ErrorComponent errorID={"1045"} />
  } else if (
    products &&
    products.length > 1 &&
    locationDataCurrency != products[0].currency_text
  ) {
    throw new Error(
      `You cannot purchase in ${products[0].currency_text}. Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information.`
    );
  } else if (products && products.length <= 0) {
    return <ErrorComponent errorID={"1046"} />
  } else {
    return (
      <>
        <div className="xs:hidden tablet:hidden laptop:flex laptop:justify-evenly">
          {benefitsTranslations &&
            desktopProductView(productData, benefitsTranslations, refundWidgetToggle)}
        </div>

        {benefitsTranslations && (
          <ProductSelectMobile
            className="laptop:hidden"
            languages={languages}
            products={products}
            selectMembership={selectMembership}
            couponObj={couponObj}
            locationData={locationData}
            isUserLogged={isUserLogged}
            locationDataCurrency={locationDataCurrency}
            businessCategories={businessCategories}
            benefitsTranslations={benefitsTranslations}
            refundWidgetToggle={refundWidgetToggle}
          />
        )}
      </>
    );
  }
}

export default Product;
